import axios from 'axios';
import { JSX } from 'react';

import toastError from 'utils/toastError';

import headers from '../headers.json';
import { UnauthorizedType } from '../types/UnauthorizedType';
import { MessageResultType } from '../types/MessageResultType';

type SuccessType = {
  success: boolean;
  message: string;
  data: MessageResultType;
};

type PromiseType =
  | { data: SuccessType; success: boolean }
  | { data: UnauthorizedType; success: boolean }
  | { data: null; success: boolean };

type DataType = {
  dataframe_id: string;
  dataframe_series: {
    [x: string]: {
      [x: string]: string | number | JSX.Element;
    };
  };
};

const PUT_DATAFRAME = async (data: DataType): Promise<PromiseType> => {
  try {
    const serverUrl = process.env.REACT_APP_SERVER_URL_BACKEND_API;
    if (!serverUrl) throw Error('Backend-URL not defined.');

    const url = `${serverUrl}/generate/update`;

    const response = await axios.put<SuccessType | UnauthorizedType>(url, data, {
      headers: {
        ...headers,
      },
      withCredentials: true,
    });

    if (response.data.success) {
      return { success: true, data: response.data };
    }

    if (response.status === 410) {
      toastError(`This resource is no longer editable because it is permanently locked!`);
    } else {
      toastError(`Error while paraphrasing process!`);
    }

    return { success: false, data: response.data };
  } catch (error) {
    console.error(error);
    if (axios.isAxiosError(error) && error.status === 410) {
      toastError(`This resource is no longer editable because it is permanently locked!`);
    } else {
      toastError(`Error while paraphrasing process!`);
    }

    return { success: false, data: null };
  }
};

export default PUT_DATAFRAME;
